<div class="message-box" *ngIf="show && notification">
  <!--<img src="assets/close-red-rectangle.svg" alt="" class="me-4 ms-4 pointer dismiss-icon" (click)="onHide()">-->
  <div class="font-16-600">{{notification.message}}</div>
</div>
